<template>
  <div class="container flex-container">
    <div
      class="container main flex-main"
      :class="{'space-for-footer':!showFooter, 'cart':isCart, 'has-topbar': hasTopbar}"
    >
      <div class="language-switch-wrapper"></div>
      <router-view/>
    </div>
    <div v-if="showFooter && !runsInEmbeddedMode" class="flex-footer">
      <Footer/>
    </div>
    <div v-if="showSidebarAndFunctionalFooter" class="flex-footer">
      <Sidebar/>
      <FunctionalFooter/>
    </div>
  </div>
  <CookieLayer/>
</template>

<script>
import Footer from './views/components/layout/Footer/Footer'
import FunctionalFooter from "@/views/components/layout/Footer/FunctionalFooter";
import Sidebar from "@/views/components/ui/Sidebar";
import CookieLayer from "@/views/components/ui/CookieLayer";
import {getEmbeddedMode} from "./utils/embeddedMode";

export default {
  components: {
    Sidebar,
    FunctionalFooter,
    Footer,
    CookieLayer
  },
  computed: {
    showFooter() {
      return (
          this.$router.currentRoute.value.path === '/login' ||
          this.$router.currentRoute.value.path === '/logout' ||
          this.$router.currentRoute.value.path === '/registrierung' ||
          this.$router.currentRoute.value.path === '/' ||
          (this.$router.currentRoute.value.name === 'NotFound' && !localStorage.getItem('isLoggedIn')) ||
          this.$router.currentRoute.value.meta.showFooter === true
      )
    },
    showSidebarAndFunctionalFooter() {
      return !this.showFooter && !this.isPublicMenuPlan
    },
    isCart() {
      return this.$router.currentRoute.value.path === '/warenkorb'
    },
    runsInEmbeddedMode() {
      return getEmbeddedMode().runsInEmbeddedMode
    },
    isPublicMenuPlan() {
      return this.$router.currentRoute.value.path === '/speiseplan-oeffentlich'
    },
    hasTopbar() {
      // currently only the registration page has a fixed topbar header
      return this.$router.currentRoute.value.path === '/registrierung'
    }
  },
  mounted() {
    this.loadGTranslate()
  },
  methods: {
    loadGTranslate() {
      window.gtranslateSettings = {
        "default_language": "de",
        "native_language_names": true,
        "detect_browser_language": true,
        "languages": ["de", "en", "uk", "ru", "ar", "pl", "cs", "tr", "fr", "es", "pt"],
        "wrapper_selector": ".language-switch-wrapper",
        "flag_size": 24,
        "switcher_horizontal_position": "inline",
        "flag_style": "3d"
      };

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  &.main {
    min-height: 50vh;
    background: $secondary;
  }

  &.space-for-footer {
    padding-bottom: 100px;
  }
}

.flex-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  background-color: #ffffff;
  box-shadow: 0 0 $shadow-blur $shadow-color;
}
.flex-main {
  justify-content: center;
  flex-direction: column;
  display: flex;
  margin: 0;
  position: relative;
}
.flex-header {
  width: 100%;
  height: 102px;
  flex-grow: 0;
}

.language-switch-wrapper {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 10;
}

.language-switch-wrapper.language-switch--register {
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  z-index: 10;
}

.flex-main.has-topbar .language-switch-wrapper:not(.language-switch--register) {
  top: 120px;
}
</style>

<style lang="scss">
body.has-android-banner {
  --android-banner-offset: 76px;
  padding-top: var(--android-banner-offset);
}

@media (min-width: 768px) {
  body.has-android-banner {
    --android-banner-offset: 84px;
  }
}
</style>
